webpackJsonp([88711629416531],{

/***/ 1592:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"UpdateStockTransferFulfillmentItemInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"expirationDate","type":{"kind":"SCALAR","name":"Date","ofType":null}},{"defaultValue":null,"description":null,"name":"fulfillmentNote","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"lotNumber","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"quantityChangeReason","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"receivedQuantity","type":{"kind":"SCALAR","name":"Decimal","ofType":null}},{"defaultValue":null,"description":null,"name":"status","type":{"kind":"ENUM","name":"StockTransferFulfillmentItemStatus","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-update-stock-transfer-fulfillment-item-input-08bb127a98dbd3ff8f00.js